export const LOTTO_REQUEST_FETCH_WIN_LOSS_REPORT = "LOTTO_REQUEST_FETCH_WIN_LOSS_REPORT";
export const LOTTO_REQUEST_FETCH_RESULT_REPORT = "LOTTO_REQUEST_FETCH_RESULT_REPORT";
export const LOTTO_MIX_REQUEST_FETCH_RESULT_REPORT = "LOTTO_MIX_REQUEST_FETCH_RESULT_REPORT";